//** Regras para mover o chat do Octadesk Suporte */

let offset = [0,0]
let isDown = false
let currentElement
let iconPositionChanged
let clientX
let clientY

window.onload = function() {
	const config = { attributes: true, attributeFilter: ['class'] }

	const callback = function(mutationsList, observer) {

		for (const mutation of mutationsList) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
				mutation.target.style.left = clientX + 'px'
				mutation.target.style.top = clientY + 'px'
				checkIframePosition(mutation.target)
			}
		}
	}

	const observer = new MutationObserver(callback)

	function checkIframePosition(iframe) {
		const rect = iframe.getBoundingClientRect()
		const iframeCenterX = rect.left + rect.width / 2
		const screenWidth = window.innerWidth
		const screenMiddleX = screenWidth / 2

		if (iframeCenterX < screenMiddleX) {
			iframe.classList.replace('octadesk-octachat-app--bottomRight', 'octadesk-octachat-app--bottomLeft')
		} else {
			iframe.classList.replace('octadesk-octachat-app--bottomLeft', 'octadesk-octachat-app--bottomRight')
		}
	}

	const observer1 = setInterval(() => {
		const iconChat = document.querySelector('#octadesk-octachat-appchat')

		if (iconChat) {
			const symbolIcon = iconChat.querySelector('iframe')

			symbolIcon.style.cursor = 'move'
			symbolIcon.style.border = '12px solid transparent'

			initDrag(iconChat)
			clearInterval(observer1)
		}
	}, 10)


	setInterval(() => {
		const frameChat = document.querySelector('.octa-widget-v2')

		if (!frameChat) {
			iconPositionChanged = false
		} else if (!iconPositionChanged) {
			observer.observe(frameChat, config)

			iconPositionChanged = true
			changePositionChat(frameChat)
		}
	}, 10)
}

function initDrag(elem) {
	currentElement = elem

	currentElement.addEventListener('mousedown', handleMouseDown, true)
	document.addEventListener('mousemove', handleMouseMove, true)
	document.addEventListener('mouseup', handleMouseUp, true)
}

function handleMouseDown(e) {
	if (e.button === 0) {
		isDown = true
		offset = [
			currentElement.offsetLeft - e.clientX,
			currentElement.offsetTop - e.clientY,
		]
	}
}

function handleMouseMove(e) {
	const frameChat = document.querySelector('.octadesk-app')

	if (isDown) {
		clientX = e.clientX
		clientY = e.clientY

		currentElement.style.left = (e.clientX + offset[0]) + 'px'
		currentElement.style.top  = (e.clientY + offset[1]) + 'px'

		if (frameChat){
			changePositionChat(frameChat)
		}
	}
}

function changePositionChat(frameChat) {
	const newLeft = currentElement.offsetLeft - frameChat.clientWidth + currentElement.clientWidth
	const newTop  = currentElement.offsetTop - frameChat.clientHeight + currentElement.clientHeight

	frameChat.style.left = newLeft + 'px'
	frameChat.style.top = newTop + 'px'
}

function handleMouseUp() {
	isDown = false
}
